module.exports = __webpack_public_path__ + "fonts/Godiva-Reguler.0feb473.woff";